var exports = {
  "AM": "Popover__ye4zKu",
  "__": "Popover_Content__CCSzC9",
  "DZ": "Heading__yoyYxQ",
  "az": "Box__yGV99v",
  "EY": "Text__b1zdHI",
};

module.exports = exports;
